var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashFillImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0001 7.33333H4.00006V10.6667C4.20642 10.6667 4.30961 10.6667 4.39659 10.6743C5.36349 10.7589 6.13008 11.5255 6.21467 12.4924C6.22228 12.5793 6.22228 12.6825 6.22228 12.8889V18C6.22228 20.8284 6.22228 22.2426 7.10096 23.1213C7.97964 24 9.39386 24 12.2223 24H15.7778C18.6063 24 20.0205 24 20.8992 23.1213C21.7778 22.2426 21.7778 20.8284 21.7778 18V12.8889C21.7778 12.6825 21.7778 12.5793 21.7854 12.4924C21.87 11.5255 22.6366 10.7589 23.6035 10.6743C23.6905 10.6667 23.7937 10.6667 24.0001 10.6667V7.33333ZM12.2223 12.8889C12.2223 12.3366 11.7745 11.8889 11.2223 11.8889C10.67 11.8889 10.2223 12.3366 10.2223 12.8889V18.4444C10.2223 18.9967 10.67 19.4444 11.2223 19.4444C11.7745 19.4444 12.2223 18.9967 12.2223 18.4444V12.8889ZM17.7778 12.8889C17.7778 12.3366 17.3301 11.8889 16.7778 11.8889C16.2255 11.8889 15.7778 12.3366 15.7778 12.8889V18.4444C15.7778 18.9967 16.2255 19.4444 16.7778 19.4444C17.3301 19.4444 17.7778 18.9967 17.7778 18.4444V12.8889Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0681 4.37059C12.1821 4.26427 12.4332 4.17033 12.7825 4.10332C13.1318 4.03632 13.5597 4 14 4C14.4403 4 14.8682 4.03632 15.2175 4.10332C15.5668 4.17033 15.8179 4.26427 15.9319 4.37059",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashFillImg);
export default __webpack_public_path__ + "static/media/trash_fill_img.9fbeabc0ec2f639b371a079651c4acf6.svg";
export { ForwardRef as ReactComponent };